module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7I7vH"))).then(() => module.bundle.root('ewmtE'));